import React from "react";
import { CRMButtonIcon } from "../../../CRMButtonIcon/CRMButtonIcon";
import { TIcon } from "../../../CRMIcon/CRMIcon";
import {
    TCaseDocumentsSort,
    getNextCaseDocumentsSort,
} from "../../../../state/actions/caseDocumentsSortPersistence";

type TCaseDocumentsSortButtonProps = {
    sort: TCaseDocumentsSort;
    onCycleSort: () => void;
};

const SortToLabel: Record<TCaseDocumentsSort, string> = {
    alphabetical: "A to Z",
    newest: "newest first",
    oldest: "oldest first",
};

const SortToIcon: Record<TCaseDocumentsSort, TIcon> = {
    alphabetical: "sort",
    newest: "sort-descending",
    oldest: "sort-ascending",
};

export const CRMLegalCaseDocumentsSortButton = (props: React.PropsWithChildren<TCaseDocumentsSortButtonProps>): JSX.Element =>
    <CRMButtonIcon
        variant="tertiary"
        icon={SortToIcon[props.sort]}
        title={`Sorted ${SortToLabel[props.sort]}. Click to sort ${SortToLabel[getNextCaseDocumentsSort(props.sort)]}.`}
        onClick={props.onCycleSort}
    />;
